import * as ngCore from '@angular/core'
import * as ds from '@attain-apps/fe/web/main/lib/design'

import * as state from '../../../../../../../../../state'

/**
 * Allows the user to select which resources to deploy
 */
@ngCore.Component({
  imports: [ds.table.Component],
  selector: 'atn-quiver-deployment-modal-resources-step',
  standalone: true,
  styleUrls: ['./component.scss'],
  templateUrl: './component.html',
})
export class Component {
  /** @see {@link state.quiver.resources.Collection} */
  public readonly resourcesEc = ngCore.inject(state.quiver.resources.Collection)

  /** Canonical embedded table input for selectable Quiver resources. */
  public readonly resourcesTableConfig = {
    collection: this.resourcesEc,
    view: {
      container: 'embedded' as const,
      search: true,
      selection: true,
    },
  } satisfies ds.table.ec.Config.Input<state.quiver.resources.TypeParams>
}
